/**/
import Grid from '@mui/material/Grid';
import { ArticulosList } from "./ArticulosList";
import { PageHeaderCard } from 'src/general_components/PageHeaderCard';
import StorefrontIcon from "@mui/icons-material/Storefront";


export function ArticulosContent() {
  let parametros_proyecto = JSON.parse(localStorage.getItem("parametros_proyecto"));
  const titulo_config = parametros_proyecto?.titulo_articulos;
  const titulo_proceso = titulo_config ? titulo_config : "Articulos/Servicios";
  return (
    <>
      <Grid style={{ marginBottom: "50px", backgroundc: "rgb(241, 243, 244)", paddingTop: 10 }}>
        
        <PageHeaderCard title={titulo_proceso} icon={<StorefrontIcon />} />
        <ArticulosList />
      </Grid>
    </>
  )
}

export default ArticulosContent;